import { render, staticRenderFns } from "./alink.vue?vue&type=template&id=eb48eb1c&scoped=true"
import script from "./alink.vue?vue&type=script&lang=js"
export * from "./alink.vue?vue&type=script&lang=js"
import style0 from "./alink.vue?vue&type=style&index=0&id=eb48eb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb48eb1c",
  null
  
)

export default component.exports